import React from 'react'
import { NextSeo } from 'next-seo'
import { paths } from '@/constants/paths'
import { fullPublisher } from '@/constants/seo'
import { HrefLang } from './HrefLang'
import { ReturnPolicyJsonLd } from './JsonLd'
import { ViewActionJsonLd } from './JsonLd/ViewActionJsonLd'
import { WebPageJsonLd } from './JsonLd/WebPageJsonLd'
import { truncateSeoDescription, truncateSeoTitle } from './truncateSeoText'
import { NextSeoPropsWithRequiredFields } from './types'

export { DefaultSeo } from './Default'
export { VideoJsonLd } from 'next-seo'
export { useDataForEpisode, getBasicPageMetaData } from './SeoHelper'
export type { NextSeoPropsWithRequiredFields } from './types'

export const Seo: React.FC<NextSeoPropsWithRequiredFields> = (props) => {
  const title = truncateSeoTitle(props.title, props.canonical)
  const description = truncateSeoDescription(props.description, props.canonical)

  return (
    <>
      <NextSeo {...props} title={title} description={description} />
      {typeof props?.path === 'string' && <HrefLang friendlyPath={props.friendlyPath} path={props.path} />}
      <WebPageJsonLd
        id={`${props.canonical}#webpage`}
        url={props.canonical}
        image="https://images.angelstudios.com/image/upload/v1637340036/angel-studios/logos/Angel-logo-black_4x_2.png"
        inLanguage="en"
        name={title}
        headline={title}
        description={description}
        isPartOf={{
          type: 'WebSite',
          id: 'https://www.angel.com/#website',
          url: 'https://www.angel.com/',
          name: 'Angel',
          publisher: fullPublisher,
        }}
      />
      <ViewActionJsonLd
        keyOverride="iOS"
        target={{ type: 'EntryPoint', urlTemplate: 'ios-app://1473663873/https/www.angel.com/' }}
      />
      <ViewActionJsonLd
        keyOverride="Android"
        target={{ type: 'EntryPoint', urlTemplate: 'android-app://com.vidangel.thechosen/https/www.angel.com/' }}
      />
      <ReturnPolicyJsonLd
        returnPolicyUrl={`${paths.getBaseURL()}${paths.legal.termsOfUse}`}
        returnPolicyCategory="full_refund"
        returnWithinDays={15}
        restockingFeeCurrency="USD"
        restockingFeeAmount={0}
      />
    </>
  )
}
